var map = {
	"./Fund.json": 79932,
	"./Manager.json": 94630,
	"./Portfolio.json": 90349,
	"components/config/dashboard-templates/PreinvestmentAnalytics/Templates/Fund.json": 79932,
	"components/config/dashboard-templates/PreinvestmentAnalytics/Templates/Manager.json": 94630,
	"components/config/dashboard-templates/PreinvestmentAnalytics/Templates/Portfolio.json": 90349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66037;